<template>
  <div class="eye-detail-card">
    <h3 class="eye-detail-card-title">{{ title }}</h3>
    <div class="eye-detail-card-header">
      <div/>
      <div v-for="(column, idx) in columns" :key="idx">{{ column.label }}</div>
    </div>
    <div class="eye-detail-card-values">
      <div
        class="eye-detail-card-value-row"
        v-for="(row, rIdx) in rows"
        :key="rIdx"
      >
        <div>{{ row.label }}</div>
        <div
          v-for="(input, inputIdx) in row.inputs"
          :class="valueClass(input.value, inputIdx)"
          :key="input.name"
        >{{ input.formattedValue || '-' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EyeDetailCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    rows: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isHighlightAvailable() {
      return this.columns.length === this.rows[0]?.inputs.length;
    },
  },
  methods: {
    useHighlight(idx) {
      return this.isHighlightAvailable && this.columns[idx].highlight === true;
    },
    valueClass(value, idx) {
      if (value === null || value === '' || value === undefined) return '';
      if (!this.useHighlight(idx)) return '';

      if (typeof value === 'number') {
        return value < 0 ? 'negative-value' : 'positive-value';
      }

      return value.startsWith('-') ? 'negative-value' : 'positive-value';
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

.eye-detail-card {
  border: $border-width solid $gray-color-500;
  border-radius: $border-radius;
  padding: $layout-spacing;

  .eye-detail-card-title {
    font-size: $font-size;
    font-weight: 600;
    text-align: center;
    margin-bottom: $border-width-lg;
  }

  .eye-detail-card-header,
  .eye-detail-card-value-row {
    align-items: center;
    display: flex;
    text-align: center;
    & > div {
      flex: 1;
    }
    & > div:first-child {
      color: $gray-color;
      flex: 0 0 $font-size;
      text-align: left;
    }
  }

  .eye-detail-card-header {
    color: $gray-color;
  }

  .eye-detail-card-values {
    color: $dark-color;
    .positive-value {
      color: $green-color-600;
    }
    .negative-value {
      color: $red-color-600;
    }
  }
}
</style>
